import React, { FC } from 'react';
import { PricingTable } from 'src/components/Pricing/PricingTable';
import { setupTypes, setupCosts, irishSetupCosts } from 'src/components/Pricing/pricesData';

import classes from './Pricing.scss';

export const SetupCharges: FC<{ isIrishUser: boolean }> = ({ isIrishUser }) => (
    <div className={classes.pricingContainer}>
        <h2 className={classes.subHeader}>Setup Charges</h2>
        <p className={classes.textParagraph}>
            When ordering a customisation for the first time, a setup charge will be applied to your order. This cost
            encompasses the conversion of the file or text you provide into a format compatible with our printing or
            embroidery machines. Our specialist Durham-based artwork team will take care of this process, ensuring it
            meets the highest standards. Additionally, we will proof it to you for approval first, to make certain it
            aligns perfectly with your expectations. The current setup charge list is as follows:
        </p>
        <PricingTable
            title="Setup"
            columnTitle1="Type"
            columnTitle2="One Time Cost"
            columnData1={setupTypes}
            columnData2={isIrishUser ? irishSetupCosts : setupCosts}
            tableSize="Wide"
        />
        <p className={classes.smallTextParagraph}>
            Remember, once you have paid a setup charge for a customisation, you will automatically not be charged this
            fee again on subsequent orders.
        </p>
    </div>
);
